import { render, staticRenderFns } from "./importAndDowloadCmp.vue?vue&type=template&id=bdd45612&scoped=true"
import script from "./importAndDowloadCmp.vue?vue&type=script&lang=js"
export * from "./importAndDowloadCmp.vue?vue&type=script&lang=js"
import style0 from "./importAndDowloadCmp.vue?vue&type=style&index=0&id=bdd45612&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd45612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd45612')) {
      api.createRecord('bdd45612', component.options)
    } else {
      api.reload('bdd45612', component.options)
    }
    module.hot.accept("./importAndDowloadCmp.vue?vue&type=template&id=bdd45612&scoped=true", function () {
      api.rerender('bdd45612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/cope/quotationManagement/cmp/PostalDelivery/importAndDowloadCmp.vue"
export default component.exports